import type { FC } from 'react'
import { Button, Dropdown } from 'components/ui'
import type { ProductQuantityProps } from '.'
import s from './product-quantity.module.css'

const ProductQuantity: FC<ProductQuantityProps> = ({
  maximum = 50,
  canChange = true,
  onChange,
  quantity = 1,
  dropdown = true,
}) => {
  function onChangeQuantity(prev: number, next: number): void {
    if (onChange) {
      onChange({ prev, next })
    }
  }

  function up(): void {
    const prev = quantity
    const next = prev + 1
    if (next > maximum) {
      return
    }
    onChangeQuantity(prev, next)
  }

  function down(): void {
    const prev = quantity
    const next = prev - 1
    if (next <= 0) {
      return
    }
    onChangeQuantity(prev, next)
  }

  function onSelect(value: any) {
    const prev = quantity
    onChangeQuantity(prev, value as unknown as number)
  }

  if (dropdown) {
    const items = []
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= 5; i++) {
      items.push({ value: i, label: i.toString() })
    }
    return (
      <Dropdown dropdownClassName={s.dropdown} placeholder="1" selected={quantity} items={items} onSelect={onSelect} />
    )
  }

  return (
    <div className={s.root}>
      {canChange && (
        <Button variant="ghost" onClick={down} disabled={quantity === 1} className={s.button}>
          -
        </Button>
      )}
      <span className={s.text}>{quantity}</span>
      {canChange && (
        <Button variant="ghost" onClick={up} disabled={quantity === maximum} className={s.button}>
          +
        </Button>
      )}
    </div>
  )
}

export default ProductQuantity
